// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_3j5si","hidden":"_2c6bB","fullScreenControl":"_1OBr8","fullScreenToggle":"qHUBa","enterIcon":"_1G0_t","exitIcon":"_1WxBR","inFullScreen":"NoNVA"};